import ImgPratikKart from "../assets/images/clean-img/pratik-kart.jpeg";
import ImgPartnerCard from "../assets/images/clean-img/shell-partner-card.jpeg";
import ImgShellTTS from "../assets/images/clean-img/tts.jpeg";
import ImgHGS from "../assets/images/clean-img/hgs-site-header.jpeg";
import ImgKKIleShellTTS from "../assets/images/clean-img/shell-tts-with-credit-card-header.jpeg";
import ImgATS from "../assets/images/clean-img/shell-filo-platform.jpeg";
export const products = [
  {
    title: "Hızlı Geçiş Sistemi (HGS)",
    subtitle: "Shell Kurumsal HGS",
    desc: "Kurumsal araç filonuzun otoyol geçişlerini Shell Taşıt Tanıma Sistemi üzerinden merkezi olarak yönetebilir, tüm HGS işlemlerinizi tek platformdan kontrol edebilirsiniz.",
    link: "/urunler/hizli-gecis-sistemi-hgs",
    img: ImgHGS,
    type: "filo",
  },
  {
    link: "/urunler/arac-takip-sistemi",
    title: "Araç Takip Sistemi",
    subtitle: "Shell Filo Platform",
    desc: "Shell Taşıt Tanıma Sistemi ile yakıt tüketim kontrolü sağladığımız müşterilerimiz, artık Shell Filo Araç Takip Sistemi ile filo yönetiminde de tam kontrol deneyimi yaşıyor.",
    img: ImgATS,
    type: "filo",
  },
  {
    title: "Kredi Kartı İle Shell TTS",
    subtitle: "Shell Taşıt Tanıma Sistemi",
    desc: "Shell Taşıt Tanıma Sistemi ile tam entegre çalışan kredi kartı ödeme çözümü sayesinde ve esnek ödeme seçenekleri ile yakıt satın alımlarınızı gerçekleştirebilirsiniz.",
    link: "/urunler/kredi-karti-ile-shell-tasit-tanima",
    img: ImgKKIleShellTTS,
    type: "filo",
  },
  {
    title: "Shell Partner Card",
    subtitle: "İş Ortaklarınız İçin Shell Partner Card",
    desc: "İş ortaklarınız ve tedarikçileriniz için özel olarak tasarlanan Shell Partner Card ile onlara akaryakıt erişimi sağlayabilir, ortaklık ilişkilerinizi güçlendirebilirsiniz.",
    link: "/urunler/shell-partner-card",
    img: ImgPartnerCard,
    type: "yakit",
  },
  {
    link: "/urunler/shell-pratik-kart",
    title: "Shell Pratik Kart",
    subtitle: "Dönemsel Yakıt Alım İhtiyaçları İçin Pratik Kart",
    desc: "İş dünyasının dönemsel yakıt ihtiyaçlarını karşılamak üzere geliştirilen Shell Pratik Kart, esnek kullanım seçenekleri ile kurumsal yakıt yönetimini kolaylaştırır.",
    img: ImgPratikKart,
    type: "yakit",
  },

  {
    link: "/urunler/shell-tasit-tanima-sistemi",
    title: "Shell Taşıt Tanıma Sistemi",
    subtitle: "Temassız, hızlı ve güvenli yakıt ikmali",
    desc: "Türkiye'nin öncü Taşıt Tanıma Sistemi olarak, ülke genelinde firmaların akaryakıt ihtiyaçları için hızlı, güvenli ve verimli bir filo yönetim çözümü sunuyoruz.",
    img: ImgShellTTS,
    type: "yakit",
  },
];
